module.exports = __webpack_public_path__ + "img/9.5cc6919b.png";